
import {getViewMessanger} from '../api/getViewMessanger';
import {setGetViewMessangerAction} from '../action';

const setGetViewMessanger = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getViewMessanger(params);
            if (data.status === 'success') {
                dispatch(setGetViewMessangerAction({
                    id: data?.data?.id,
                    link: data?.data?.link,
                    type: data?.data?.type,
                    language: data?.data?.language,
                    website: data?.data?.website
                }));       
            }
    
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetViewMessanger
}